export const DEFAULT_PATIENT_MONITORING_ENABLED = JSON.parse(
  (process.env.VUE_APP_DEFAULT_PATIENT_MONITORING_ENABLED || 'False').toLowerCase()
)
export const DEFAULT_MY_PATIENTS_ENABLED = JSON.parse(
  (process.env.VUE_APP_DEFAULT_MY_PATIENTS_ENABLED || 'True').toLowerCase()
)
export const DEFAULT_SYNC_PATIENTS = JSON.parse((process.env.VUE_APP_DEFAULT_SYNC_PATIENTS || 'False').toLowerCase())
export const DEFAULT_SYNC_ALL_PATIENTS = JSON.parse(
  (process.env.VUE_APP_DEFAULT_SYNC_ALL_PATIENTS || 'False').toLowerCase()
)
export const DEFAULT_SYNC_CAREGIVERS = JSON.parse((process.env.VUE_APP_DEFAULT_SYNC_CAREGIVERS || 'True').toLowerCase())
export const DEFAULT_SYNC_MINIMAL_DATA = JSON.parse(
  (process.env.VUE_APP_DEFAULT_SYNC_MINIMAL_DATA || 'False').toLowerCase()
)
export const DEFAULT_MATCH_RESIDENT_NUMBER = JSON.parse(
  (process.env.VUE_APP_DEFAULT_MATCH_RESIDENT_NUMBER || 'False').toLowerCase()
)
export const DEFAULT_MATCH_ROOM_NUMBER = JSON.parse(
  (process.env.VUE_APP_DEFAULT_MATCH_ROOM_NUMBER || 'False').toLowerCase()
)
